import RoleCombobox from "./combobox.js"

RoleCombobox.define()

export default RoleCombobox
